import extend from 'lodash/extend';
import isUndefined from 'lodash/isUndefined';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';

const $hnxApi = function () {
	const API = {};

	Object.defineProperty(API, '$register', {
		configurable: false,
		writable: false,
		value (name, api) {
			if (name.indexOf('$') === 0) {
				throw new Error('Identifiers cannot start with "$".');
			}
			if (!isUndefined(this[name])) {
				throw new Error('Identifier already in use.');
			}
			if (!isFunction(api) && !isObject(api)) {
				throw new Error('API must be a function or an object.');
			}

			Object.defineProperty(API, name, {
				configurable: false,
				writable: false,
				value: api
			});

			return api;
		}
	});

	Object.defineProperty(API, '$extend', {
		configurable: false,
		writable: false,
		value (name, api) {
			if (isUndefined(this[name])) {
				return this.$register(name, api);
			}
			if (!isObject(api)) {
				throw new Error('Only objects can be extended.');
			}

			return extend(this[name], api);
		}
	});

	return API;
}();

export default $hnxApi;
